export const fullSpaceAbsoluteStyle = `
  position: absolute !important;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;
export const fullSpaceFixedStyle = `
  position: fixed !important;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;